import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { QuestionObjectiveNoMath, QuestionSubjective } from './question.model';
import { ErrorResponse } from '@/utils/response';
import { axios, CustomAxiosResponse } from '@/utils/axios';

export interface QuestionsAdminStoreInterface {
  adminObjectives: QuestionObjectiveNoMath[];
  adminSubjectives: QuestionSubjective[];
  error: ErrorResponse | null;
  fetchQuestions(subjectUuid: string): Promise<void>;
}

@Module({
  namespaced: true,
  dynamic: true,
  name: 'questions-admin',
  store,
})
class QuestionsAdminStore extends VuexModule {
  adminObjectives: QuestionObjectiveNoMath[] = [];
  adminSubjectives: QuestionSubjective[] = [];
  error: ErrorResponse | null = null;

  @Mutation
  updateAdminObjectives(params: QuestionObjectiveNoMath[]) {
    this.adminObjectives = params;
  }

  @Mutation
  updateAdminSubjectives(params: QuestionSubjective[]) {
    this.adminSubjectives = params;
  }

  @Mutation
  setError(params: ErrorResponse) {
    this.error = params;
  }

  @Action
  async fetchQuestions(subjectUuid: string): Promise<void> {
    this.context.commit('updateAdminObjectives', []);
    this.context.commit('updateAdminSubjectives', []);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(
        `questions/dashboard/${subjectUuid}`,
      );

      this.context.commit('updateAdminObjectives', data.adminObjectives);
      this.context.commit('updateAdminSubjectives', data.adminSubjectives);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }
}

export default getModule(QuestionsAdminStore);
